import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import _isNaN from "lodash/isNaN";
import _inRange from "lodash/inRange";
import _debounce from "lodash/debounce";
import _isObjectLike from "lodash/isObjectLike";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.is-array.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useRef, useCallback, useEffect, useImperativeHandle } from 'react';
import { uuid } from '../../utils';
var itemIdAttr = 'data-autocomplete-option-number';
export var useAutocomplete = function useAutocomplete(incomingProps, ref) {
  var value = incomingProps.value,
      options = incomingProps.options,
      getOptions = incomingProps.getOptions,
      onInputChange = incomingProps.onInputChange,
      onBlur = incomingProps.onBlur,
      onChange = incomingProps.onChange,
      _incomingProps$displa = incomingProps.displayKey,
      displayKey = _incomingProps$displa === void 0 ? 'label' : _incomingProps$displa,
      _incomingProps$unique = incomingProps.uniqueKey,
      uniqueKey = _incomingProps$unique === void 0 ? 'value' : _incomingProps$unique;

  var hasDynamicSuggestions = _isFunction(getOptions);

  var _useState = useState(value !== null && value !== void 0 ? value : ''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(options !== null && options !== void 0 ? options : []),
      _useState4 = _slicedToArray(_useState3, 2),
      suggestions = _useState4[0],
      setSuggestions = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isOpen = _useState6[0],
      setIsOpen = _useState6[1];

  var lastSearch = useRef(null);
  var rootNodeRef = useRef(null);
  var inputRef = useRef(null);
  var idRef = useRef(uuid());
  var performAsyncSearch = useCallback(_debounce( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newValue) {
      var result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getOptions(newValue);

            case 2:
              result = _context.sent;

              if (result !== null && result !== void 0 && result.length) {
                setSuggestions(result !== null && result !== void 0 ? result : []);
                setIsOpen(true);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), 700), [getOptions]);
  useImperativeHandle(ref, function () {
    return {
      isOpen: isOpen,
      suggestions: suggestions,
      inputValue: inputValue,
      rootNodeRef: rootNodeRef,
      inputRef: inputRef,
      changeIsOpen: setIsOpen,
      changeSuggestions: setSuggestions,
      changeInputValue: setInputValue,
      triggerNewSearch: function triggerNewSearch(newVal) {
        return performSearch(newVal);
      }
    };
  });
  useEffect(function () {
    performSearch(inputValue);
  }, [options]);

  var handleChange = function handleChange(_ref2) {
    var input = _ref2.target.value;
    setInputValue(input);
    _isFunction(onInputChange) && onInputChange(input.trim());
    performSearch(input.trim());
  };

  var handleBlur = function handleBlur(event) {
    var _target$parentNode, _target$parentNode$pa;

    _isFunction(onBlur) && onBlur(event);

    var _ref3 = event !== null && event !== void 0 ? event : {},
        relatedTarget = _ref3.relatedTarget,
        target = _ref3.target;

    if (!(target !== null && target !== void 0 && (_target$parentNode = target.parentNode) !== null && _target$parentNode !== void 0 && (_target$parentNode$pa = _target$parentNode.parentNode) !== null && _target$parentNode$pa !== void 0 && _target$parentNode$pa.contains(relatedTarget))) setIsOpen(false);
  };

  var handleSelect = function handleSelect(item) {
    setTimeout(function () {
      setIsOpen(false);
      setInputValue(_isObjectLike(item) ? item[displayKey] : item);
      _isFunction(onChange) && onChange(item);
    });
  };

  var handleInputKeyDown = function handleInputKeyDown(e) {
    if (suggestions.length && (e.keyCode === 40 || e.keyCode === 38)) {
      var _document$querySelect;

      var nextIndex = e.keyCode === 40 ? 0 : suggestions.length - 1;
      (_document$querySelect = document.querySelector("[".concat(itemIdAttr, "='").concat(nextIndex, "']"))) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.focus();
    }

    if (e.keyCode === 27) e.target.blur();
  };

  var handleItemKeyDown = function handleItemKeyDown(e) {
    var target = e.target;

    if (e.keyCode === 40 || e.keyCode === 38) {
      var _document$querySelect2;

      var maxElement = suggestions.length - 1;
      var activeNode = target;
      var currentIndex = Number(activeNode.getAttribute(itemIdAttr));
      if (_isNaN(currentIndex)) return;
      var nextIndex = currentIndex + (e.keyCode === 40 ? 1 : -1);
      _inRange(nextIndex, maxElement + 1) ? (_document$querySelect2 = document.querySelector("[".concat(itemIdAttr, "='").concat(nextIndex, "']"))) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.focus() : inputRef.current.focus();
    }

    if (e.keyCode === 27) target.blur();
    if (e.keyCode === 13) handleSelect(suggestions[Number(target.getAttribute(itemIdAttr))]);
  };

  var performSearch = function performSearch(newValue) {
    if (hasDynamicSuggestions) {
      if (lastSearch.current === newValue) return;
      if ((newValue === null || newValue === void 0 ? void 0 : newValue.length) < 3) return setSuggestions([]);
      lastSearch.current = newValue;
      performAsyncSearch(newValue);
    }

    var suggestionsList = options === null || options === void 0 ? void 0 : options.filter(function (el) {
      var _el$uniqueKey;

      return String(_isObjectLike(el) ? (_el$uniqueKey = el[uniqueKey]) !== null && _el$uniqueKey !== void 0 ? _el$uniqueKey : el[displayKey] : el).toLowerCase().includes(newValue.toLowerCase());
    });
    return setSuggestions(suggestionsList !== null && suggestionsList !== void 0 ? suggestionsList : []);
  };

  return {
    inputProps: {
      id: idRef.current,
      ref: inputRef,
      value: inputValue,
      placeholder: incomingProps.placeholder,
      onFocus: function onFocus() {
        return setIsOpen(true);
      },
      onChange: handleChange,
      onKeyDown: handleInputKeyDown,
      onBlur: handleBlur,
      maxLength: '2048',
      type: 'text',
      spellCheck: 'false',
      'aria-autocomplete': 'both',
      'aria-haspopup': 'false',
      autoCapitalize: 'off',
      autoComplete: 'off',
      autoCorrect: 'off'
    },
    suggestionItemProps: {
      itemIdAttr: itemIdAttr,
      onKeyDown: handleItemKeyDown,
      onClick: handleSelect
    },
    isOpen: isOpen,
    suggestions: suggestions,
    rootNodeRef: rootNodeRef
  };
};